<template>
  <ul
    class="commentsUl_waterfall"
    :style="columnCount"
    :class="comment_mode == 'page' ? 'comment_mode_page' : ''"
  >
    <template v-for="(item, index) in new_comments_list">
      <li
        @click="() => (comment_mode == 'page' && $emit('cardClick', index, item))"
        v-if="item.comment_approved && item.status == 'publish'"
        :key="item.comment_ID"
      >
        <div class="waterfall_box">
          <div class="waterfall_picture_num" v-if="item.gallery.length > 1">
            {{ item.gallery.length }}
          </div>
          <div class="waterfall_commentsphoto" v-if="item.gallery.length">
            <v-lazy-img @click.native="comment_mode !== 'page' && showBigImg(item.gallery, 0)" :data-url="item.gallery[0].url" ></v-lazy-img>
          </div>
          <!-- <div class="waterfall_person_photo icon-cm-icontouxiang iconfont"></div> -->
          <div class="waterfall_main">
            <div class="person_info text-left">
              <span class="name secondary_title">{{ item.name }}</span>
              <span
                class="country secondary_title"
                v-if="
                  (item.country &&
                    comment_mode != 'page' &&
                    comment.comment_country == 'yes') ||
                  (comment_mode == 'page' &&
                    comment.store_comment_country == 'yes')
                "
              >
                <country-flag
                  v-if="item && item.country"
                  :country="item.country=='UK'?'GB':item.country"
                  size="small"
                />
                {{ item.country }}
              </span>
              <p class="country_time secondary_title">
                <span
                  class="date"
                  v-if="
                    (comment_mode != 'page' && comment.comment_time == 'yes') ||
                    (comment_mode == 'page' &&
                      comment.store_comment_time == 'yes')
                  "
                >
                  {{ item.comment_date }}
                </span>
              </p>
              <div class="star">
                <v-commentsstar
                  :disabled="true"
                  :average_rating="item.rating"
                  font_size="16"
                ></v-commentsstar>
              </div>
              <p class="detail page_text_font" v-text="item.content"></p>
              <div v-if="comment_mode != 'page'">
                <p
                  class="helpful_num secondary_title"
                  v-if="
                    comment.comment_account == 'yes' && item.like_account > 0
                  "
                >
                  {{ item.like_account == "1" ? "one" : item.like_account }}
                  people found this helpful
                </p>
                <span
                  class="help secondary_title"
                  v-show="item.help_show"
                  @click="comment_helpful(item, index)"
                  >{{ $t("comment.helpful") }}</span
                >
                <span
                  class="help_tips secondary_title"
                  v-show="!item.help_show"
                  >{{ $t("comment.thank_you_for_your_feedback") }}</span
                >
                <span
                  class="report secondary_title"
                  v-show="item.abuse_show"
                  @click="click_abuse(item, index)"
                  >{{ $t("comment.report_as_inappropriate") }}</span
                >
                <span class="report page_text_font" v-show="!item.abuse_show">{{
                  $t("comment.this_review_has_been_reported")
                }}</span>
              </div>
            </div>
          </div>
          <v-product-info
            v-if="comment_mode == 'page' && item.products"
            :procuts_info="item.products"
          ></v-product-info>
          <v-commentReply
            v-if="item.reply && item.reply.length"
            :reply="item.reply"
          ></v-commentReply>
        </div>
      </li>
    </template>
  </ul>
</template>
<script>
import vCommentsstar from "./commentsstar";
import vCommentReply from "./commentReply.vue";
import vProductInfo from "./productInfo";

export default {
  props: [
    "comment_mode",
    "comment",
    "new_comments_list",
    "showBigImg",
    "comment_helpful",
    "click_abuse",
    "comment_info"
  ],
  // 卡片点击
  $emits: ['cardClick'],
  data() {
    return {};
  },
  methods: {
  },
  components: {
    vCommentsstar,
    CountryFlag: resolve => {require(['vue-country-flag'], resolve)},
    vCommentReply,
    vProductInfo,
  },
  computed: {
    // 瀑布流列数
    columnCount() {
      // 评论页面
      if (this.comment_info) {
        return {
          '--comment-col-count': this.comment_info?.row_amount || 5
        } 
      }

      if (this.comment_mode == 'page' && this.comment.store_count) {
        return {
          '--comment-col-count': this.comment.store_count
        }
      }

      return {
        '--comment-col-count': 4
      }
    }
  }
};
</script>
<style scoped lang='scss'>
.commentsUl_waterfall {
  margin: 0;
  padding: 0;
  column-count: 4;
  margin-bottom: 20px;
  column-count: var(--comment-col-count);
  // column-gap: 0;
  li {
    margin: 0;
    -webkit-tap-highlight-color: transparent;
    outline: 0;
    list-style: none;
    box-sizing: border-box;
    break-inside: avoid;
    padding: 10px;
    padding-top: 20px;
    .waterfall_box {
      margin: 0;
      padding: 0;
      -webkit-tap-highlight-color: transparent;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      text-align: left;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      .waterfall_picture_num {
        text-align: left;
        margin: 0;
        -webkit-tap-highlight-color: transparent;
        position: absolute;
        right: 10px;
        top: 10px;
        background: rgba(0, 0, 0, 0.35);
        color: rgba(255, 255, 255, 0.9);
        padding: 0 15px;
        border-radius: 10px;
      }
      .waterfall_commentsphoto {
        width: 100%;
        text-align: left;
        margin: 0;
        padding: 0;
        -webkit-tap-highlight-color: transparent;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        img {
          display: block;
          width: 100%;
          margin: 0;
          padding: 0;
          -webkit-tap-highlight-color: transparent;
          max-width: 100%;
          height: auto;
          opacity: 1;
        }
      }
      .waterfall_person_photo {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        overflow: hidden;
        margin: -20px auto 0;
        font-size: 33px;
        line-height: 58px;
        background-color: #999;
        color: white;
      }
      .waterfall_main {
        padding: 20px 12px;
        box-sizing: border-box;
        width: 100%;
        .person_info {
          .country {
            vertical-align: middle;
            font-size: 16px;
            font-weight: bold;
            .flag {
              box-sizing: content-box;
              border: 1px solid #dedede;
              margin-right: -14px;
            }
          }
          .name {
            text-align: left;
            margin: 0;
            padding: 0;
            -webkit-tap-highlight-color: transparent;
            font-size: 16px;
            color: #222;
            display: inline-block;
            vertical-align: middle;
            line-height: 22px;
            font-weight: bold;
          }
          .country_time {
            margin-top: 2px;
            height: 18px;
            .date {
              text-align: left;
              margin: 0;
              padding: 0;
              -webkit-tap-highlight-color: transparent;
              font-size: 12px;
              color: #999;
            }
          }
          .star {
            margin-top: 14px;
            margin-bottom: 11px;
          }
          .detail {
            margin-top: 11px;
            margin-bottom: 20px;
            font-size: 14px !important;
            text-align: left;
            -webkit-tap-highlight-color: transparent;
            line-height: 24px;
            word-break: break-word;
            color: #222;
          }
          .helpful_num {
            text-align: left;
            padding: 0;
            -webkit-tap-highlight-color: transparent;
            margin: 12px 0;
            font-size: 12px;
            color: #999;
            margin-top: 0;
          }
          .help {
            margin: 0;
            padding: 7px 14px;
            -webkit-tap-highlight-color: transparent;
            // width: 68px;
            max-width: 50%;
            background: #fff;
            display: inline-block;
            text-align: center;
            border: 1px solid #ddd;
            border-radius: 2px;
            cursor: pointer;
            color: #3b3b3b;
            font-size: 14px;
            display: inline;
          }
          .help_tips {
            text-align: left;
            margin: 0;
            padding: 0;
            -webkit-tap-highlight-color: transparent;
            color: #008100;
            font-size: 14px;
            display: inline;
            &::before {
              content: "\e62a";
              font-size: 14px;
              font-family: iconfont !important;
              font-style: normal;
              -webkit-font-smoothing: antialiased;
              -moz-osx-font-smoothing: grayscale;
              margin-right: 5px;
            }
          }
          .report {
            margin: 0;
            padding: 0;
            -webkit-tap-highlight-color: transparent;
            margin-top: 12px;
            cursor: pointer;
            font-size: 12px;
            color: #222222;
            text-align: left;
            display: block;
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}
.comment_mode_page {
  li {
    cursor: pointer;
    padding: 10px 0 10px;
    .waterfall_box {
      box-shadow: 0 0 3px rgb(0 0 0 / 20%);
      padding-bottom: 0;
      &:hover {
        background: #f8f8f8;
      }
      .waterfall_main {
        .person_info {
          .detail {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
             margin: 0;
          }
        }
      }
    }
  }
}

@media screen and(max-width: 768px) {
  .commentsUl_waterfall {
    column-count: 2;
  }
}

@media screen and(max-width: 374px) {
  .commentsUl_waterfall {
    column-count: 1;
  }
}
</style>
